var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox-group',_vm._g(_vm._b({class:{
    'boole-small' : _vm.size === 'small'
  },attrs:{"multiple":""},model:{value:(_vm.booleValue),callback:function ($$v) {_vm.booleValue=$$v},expression:"booleValue"}},'el-checkbox-group',Object.assign({}, _vm.$props),false),_vm.$listeners),[_c('el-checkbox',{attrs:{"label":_vm.optionValue}},[_vm._v(_vm._s(_vm.optionValue))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }